import React, { useEffect, useReducer } from "react";
import DocContext from "./Context/DocContext";
import {
    docReducer,
    GET_SPONSOR_CHILDREN,
    GET_SPONSOR_CHILD,
    GET_CHILD_PHOTO,
    SELECT_DOC_CODE,
    SET_LOADING,
    DISABLE_MENU,
    VIEW_MESSAGE,
    CLEAR_MESSAGE,
    SELECT_CHILD
} from "./Context/reducer";
import api from "../../Constants/api";
import Select from "../El/Select";
import fetchClass from "../shared/httpClass";
import DocumentBody from "./DocumentBody";
import Loader from "../shared/Loader";
import defaultPhoto from "../../../assets/img/profile_default_v01.png";

const url = api.urlV2;

const initialState = {
    children: [],
    selectedChildPhoto: null,
    child: {},
    code: null,
    loading: false,
    menuDisabled: false
};

const DocumentViewer = () => {
    const pid = sessionStorage.getItem("pid");
    const [store, dispatch] = useReducer(docReducer, initialState);

    useEffect(() => {
        getSponsorChildren();

        return () => console.log("unmounting...");
    }, []);

    const request = async endpoint => {
        const endpointUrl = new URL(url + endpoint);

        if (pid) endpointUrl.search = new URLSearchParams({ pid });

        const request = new fetchClass(endpointUrl, "GET");

        setLoading(true);
        let response = await request.http();
        setLoading(false);

        return response;
    };

    function setLoading(isloading) {
        dispatch({ type: SET_LOADING, isloading });
    }

    function disableMenu() {
        dispatch({ type: DISABLE_MENU });
    }

    function getSponsorChildren() {
        request("/child/get-sponsor-children-ids").then(res => {
            dispatch({ type: GET_SPONSOR_CHILDREN, data: res });
        });
    }

    function getSponsorChild(childId) {
        //console.log("get sponsor child", childId);
        request(`/child/get-child/${childId}`).then(res => {
            dispatch({ type: GET_SPONSOR_CHILD, data: { ...res } });
        });
    }

    function getChildPhoto(childId) {
        request(`/child/photo/${childId}`).then(res => {
            dispatch({ type: GET_CHILD_PHOTO, data: { ...res } });
        });
    }

    function selectMenu(code) {
        dispatch({ type: SELECT_DOC_CODE, code });
    }

    function viewMessage(data, index) {
        dispatch({ type: VIEW_MESSAGE, data, index });
    }

    function clearMessage() {
        dispatch({ type: CLEAR_MESSAGE });
    }

    const handleChange = async e => {
        // console.log(e);
        // console.log("meeeh");

        const value = e.target.value;

        dispatch({ type: SELECT_CHILD, childId: value });

        await getSponsorChild(value);

        getChildPhoto(value);
    };

    function displayChildPhoto() {
        if (store.selectedChildPhoto !== null && store.selectedChildPhoto.hasOwnProperty('photo')) {
            return (
                <img src={store.selectedChildPhoto.photo[1].url} alt="child" />
            );
        }

        return <img src={defaultPhoto} alt="child" />;
    }

    return (
        <div className="document-viewer">
            <div className="top-bar">
                <div className="side-by-side left">{displayChildPhoto()}</div>

                <div className="side-by-side right">
                    <h3 className="mt-0">Check letters from:</h3>
                    <br />
                    <Select
                        options={store.children}
                        defaultValue={"Select Child"}
                        classes="form-control text-16"
                        change={handleChange}
                        disabled={store.loading}
                    />
                </div>
            </div>

            <DocContext.Provider
                value={{
                    store,
                    selectMenu,
                    disableMenu,
                    viewMessage,
                    clearMessage,
                    getChildPhoto,
                    pid
                }}
            >
                {store.loading ? (
                    <p className="text-center">
                        <Loader />
                    </p>
                ) : (
                    <DocumentBody />
                )}
            </DocContext.Provider>
        </div>
    );
};

export default DocumentViewer;
